import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const QuestionTitle = ({ questionIdx, question }) => {
    return (
        <div className='question-title-container'>
            <span>{questionIdx + 1}</span>
            <p>{question.title}</p>
        </div>
    );
};

QuestionTitle.propTypes = {
    questionIdx: PropTypes.number,
    question: PropTypes.object
};

QuestionTitle.defaultProps = {
    questionIdx: null,
    question: {}
};

export default QuestionTitle;
